import React from 'react';
import { Grid } from 'vindi-ds-components';
import styles from './styles';

function TitleContainer({ children }) {
  return (
    <Grid style={styles.titleContainer} item lg={12}>
      {children}
    </Grid>
  );
}

export default TitleContainer;
